import { parse } from 'qs';

import { BackLinkInterface } from '~/checkout/interfaces/back-link.interface';

export function urlToBackLink(url: string): BackLinkInterface {
  if (!url) {
    return { path: '/' };
  }

  const [path, queryString] = url.split('?');

  if (!queryString) {
    return {
      path,
    };
  }

  // depth 0 allow field[operator]=value to be parsed in a non-nested way
  // so it is compliant with routerLink expected format
  return {
    path,
    queryParams: { ...parse(queryString, { depth: 0 }) },
  };
}
